import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function Dis() {
  return (
    <div>
      <Container>
        <Row>
          <Col md={6}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
            impedit repellendus ullam ex adipisci, voluptas reiciendis
            consequuntur at, porro mollitia placeat quasi veniam rerum ut
            possimus veritatis tempora sint obcaecati?
          </Col>
          <Col md={6}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
            impedit repellendus ullam ex adipisci, voluptas reiciendis
            consequuntur at, porro mollitia placeat quasi veniam rerum ut
            possimus veritatis tempora sint obcaecati?
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
            impedit repellendus ullam ex adipisci, voluptas reiciendis
            consequuntur at, porro mollitia placeat quasi veniam rerum ut
            possimus veritatis tempora sint obcaecati?
          </Col>
          <Col md={6}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
            impedit repellendus ullam ex adipisci, voluptas reiciendis
            consequuntur at, porro mollitia placeat quasi veniam rerum ut
            possimus veritatis tempora sint obcaecati?
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Dis;
